import {action, computed} from 'mobx';

import {EXPIRES_IN, EXPIRES_PENDING, EXPIRE_TIME} from '../../../constants/storeConstants';
import {STATE_FULFILLED, STATE_PENDING, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiBaseStore from '../common/apiBaseStore';

/**
 * ApiContentFolderGetAllStore
 */
class ApiContentFolderGetAllStore extends ApiBaseStore {
  /**
   * Whether or not the folders list is empty.
   *
   * @returns {?boolean}
   */
  @computed get isEmpty() {
    if (this.state !== STATE_FULFILLED) {
      return null;
    }

    const fulfilled = this.getFulfilled();
    return Boolean(!fulfilled || !fulfilled.length);
  }

  /**
   * Fetches content folders from the server. (Should list of the user's folders)
   */
  @action makeRequest() {
    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.contentFolderGetAll(true)
      .then(action('contentFolderGetAllSuccess', (contentFolders) => {
        if (!Array.isArray(contentFolders)) {
          throw new Error('Server did not return an array for .contentFolderGetAll request');
        }

        this.state = STATE_FULFILLED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;
        this.data = contentFolders;
        this.error = null;
      })).catch(action('contentFolderGetAllError', (contentFolderGetAllError) => {
        this.state = STATE_REJECTED;
        this[EXPIRE_TIME] = null;
        this.data = null;
        this.error = contentFolderGetAllError;
      }));
  }
}

export default new ApiContentFolderGetAllStore();
